import React, { useState } from 'react';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import { JudgementOnMeritsType } from 'containers/LawyerLegalProceedingsPage/typings';
import { get, isEmpty } from 'lodash';
import { LISTINGS } from 'containers/data-structure';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import CorrectionalContestationDialog from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CorrectionalContestationDialog';
import { Listings } from 'containers/AppContainer/typings';
import { getMotifs } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import JudgementOnMeritsMotifRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/JudgementOnMeritsMotifRecap';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';

export interface CorrectionalJudgementManagerRecapProps {
  intl: IntlShape;
  listings: Listings;
  judgementOnMerits: JudgementOnMeritsType | {};
  correctionalContestationReasons: {
    reasons: Set<number>;
    instruction: string;
  };
  setCorrectionalContestationReasons: Function;
  isContested: Boolean;
  isConsultation: Boolean;
}
const CorrectionalJudgementManagerRecap: React.FC<CorrectionalJudgementManagerRecapProps> = ({
  listings,
  judgementOnMerits,
  correctionalContestationReasons,
  setCorrectionalContestationReasons,
  isContested,
  ...props
}): JSX.Element => {
  const [isContestationDialogOpen, setIsContestationDialogOpen] = useState<
    boolean
  >(false);

  const handleOpenContestation = () => {
    setIsContestationDialogOpen(true);
  };

  const motifListCorrectional = [
    ...getMotifs(
      judgementOnMerits,
      get(listings, LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS, []),
    ),
  ];
  motifListCorrectional.pop();

  return (
    <div className="correctional-judgement">
      {!isEmpty(motifListCorrectional) && (
        <JudgementOnMeritsMotifRecap
          motifs={getMotifs(
            judgementOnMerits,
            get(
              listings,
              LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS,
              [],
            ),
          )}
        />
      )}
      {userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) &&
      !props.isConsultation &&
      isEmpty(correctionalContestationReasons.reasons)
        ? !isContested && (
            <PrimaryButton
              background={BUTTON_COLORS.PRIMARY_BLUE}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
              title={translate(messages.challenge, props)}
              onClick={handleOpenContestation}
            />
          )
        : userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) &&
          !props.isConsultation &&
          !isContested && (
            <PrimaryButton
              background={BUTTON_COLORS.GOLDEN_BUTTON_TITLE}
              border={BUTTON_COLORS.GOLDEN_BUTTON_TITLE}
              titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
              title={translate(messages.challenged, props)}
            />
          )}
      <CorrectionalContestationDialog
        listings={listings}
        setCorrectionalContestationReasons={setCorrectionalContestationReasons}
        correctionalContestationReasons={correctionalContestationReasons}
        isOpen={isContestationDialogOpen}
        setIsContestationDialogOpen={setIsContestationDialogOpen}
      />
    </div>
  );
};

export default injectIntl(CorrectionalJudgementManagerRecap);
